import React from "react"
import { useReactReplJS } from "awesome-react-repl"

const Repl = ({title}) => {
  const { submitCode, ReactRepl } = useReactReplJS()
  console.log(submitCode)
  return  (
    <div className="repl">
      <ReactRepl
        title={title}
        tabs={["Javascript"]}
        selectedTab="Javascript"
        initiallyExecute={[`a = 5`, `b = 3.14`,`c = "Hello World!"`, `d = [1,2,3,4,5]`]}
        lines={[
          { type: "input", value: "let obj = { something: 2 };\n var t = 2" },
        ]}
      />
    </div>
  )
}

export default Repl

// onChangeTab={action("onChangeTab")}
// onSubmit={action("onSubmit")}
// onClear={action("onClear")}
